import { forwardRef } from 'react';
import { resizeThumbnailUrl } from '@embed/components/helpers/resizeThumbnailUrl';
import { THUMBNAIL_SIZE_LARGE } from '@embed/styled';
import { ThumbnailBlurhash } from './ThumbnailBlurhash';
/**
 * Composition of thumbnail blurhash and picture element
 * with srcset for webp and jpg
 */
const ThumbnailPicture = forwardRef((props, ref) => {
    const { src, options = {}, blurhash, alt, ...rest } = props;
    const regularSize = options?.size || THUMBNAIL_SIZE_LARGE;
    const doubleSize = (options?.size || THUMBNAIL_SIZE_LARGE).map((s) => s * 2);
    const retinaWebpSrc = resizeThumbnailUrl(src, {
        ...options,
        format: 'webp',
        size: doubleSize,
    });
    const regularWebpSrc = resizeThumbnailUrl(src, {
        ...options,
        format: 'webp',
        size: regularSize,
    });
    const defaultSrc = resizeThumbnailUrl(src, {
        ...options,
        format: 'jpg',
        size: regularSize,
    });
    return (<>
      <ThumbnailBlurhash blurhash={blurhash}/>
      <picture>
        <source srcSet={`${regularWebpSrc} 1x, ${retinaWebpSrc} 2x`} type="image/webp"/>
        <img ref={ref} src={defaultSrc} alt={alt} {...rest}/>
      </picture>
    </>);
});
export default ThumbnailPicture;
